var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Scissors component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconScissors extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.60547 5.36671C2.60547 3.84145 3.84194 2.60498 5.3672 2.60498C6.89246 2.60498 8.12893 3.84145 8.12893 5.36671C8.12893 6.89197 6.89246 8.12844 5.3672 8.12844C3.84194 8.12844 2.60547 6.89197 2.60547 5.36671ZM5.3672 1.10498C3.01351 1.10498 1.10547 3.01302 1.10547 5.36671C1.10547 7.3155 2.41351 8.95879 4.19952 9.46649L8.59489 12.0003L4.20511 14.531C2.41624 15.0368 1.10547 16.6815 1.10547 18.6323C1.10547 20.986 3.01351 22.8941 5.3672 22.8941C7.72089 22.8941 9.62893 20.986 9.62893 18.6323C9.62893 16.8402 8.52274 15.3064 6.95591 14.6766L10.0966 12.866L21.771 19.5961C22.1299 19.803 22.5885 19.6798 22.7954 19.3209C23.0022 18.9621 22.879 18.5035 22.5202 18.2966L11.5983 12.0003L22.5202 5.70409C22.879 5.49722 23.0022 5.0386 22.7954 4.67975C22.5885 4.32089 22.1299 4.19769 21.771 4.40456L10.0966 11.1346L6.95424 9.32314C8.52196 8.6937 9.62893 7.15948 9.62893 5.36671C9.62893 3.01302 7.72089 1.10498 5.3672 1.10498ZM4.6601 15.962C4.6729 15.959 4.68567 15.9558 4.69839 15.9521C4.91254 15.8989 5.13657 15.8706 5.3672 15.8706C6.89246 15.8706 8.12893 17.1071 8.12893 18.6323C8.12893 20.1576 6.89246 21.3941 5.3672 21.3941C3.84194 21.3941 2.60547 20.1576 2.60547 18.6323C2.60547 17.3515 3.47741 16.2743 4.6601 15.962Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconScissors.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconScissors.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconScissors.prototype, "size", void 0);
if (customElements.get('cat-icon-scissors') === undefined) {
    customElements.define('cat-icon-scissors', BlocksIconScissors);
}
